




















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change'
  },
})

export default class InputRadio extends Vue {
  @Prop({ default: 'radio-input' }) readonly id!: string
  @Prop({ default: 'radio' }) readonly type!: string
  @Prop() readonly label!: string
  @Prop() readonly value!: string
  @Prop() readonly checked!: boolean
}
